
















































/**
 * 为什么【总览】和【收入分析】大体一致，为什么不直接复用icnome-data组件呢？
 * 因为【总览】和【收入分析】毕竟是两个独立模块（未来还会有其他模块），未来产品可能单独针对某个模块进行调整
 * 耦合太重，不利于后续维护，所以最终决定拆分，模块之间单独维护
 * TODO: 有时间可以考虑将getDashboard、cardData、getCardChart、getCorePannelLineChart 等相似度高的代码单独抽成一个hooks。
**/

import { ref, computed, defineComponent, watch } from '@vue/composition-api';
import ChartsCard from '../charts-card.vue';
import ChartsLine from '../charts-line.vue';
import SelectNav from '../select-nav.vue';
import { useOverviewData } from '../../hooks/overview-data';
import { createFilterForm, filterSetting } from '../../filter';
import { handleErrorMessageToast, handleWarningMessageToast } from '@/common/util';

import {
    SelectorsType,
} from '../../types';
export default defineComponent({
    name: "overview-data", // 总览
    components: {
        ChartsCard,
        ChartsLine,
        SelectNav
    },
    props: {
        tabActive: {
            type: String,
            default: ''
        },
        appId: {
            type: String,
            required: true
        },
        gameType: {
            type: String,
            required: true,
            // default: 'iaa'
        }
    },
    setup(props, context) {
        const {
            fillterForm,
            dashboardData,
            newCardConfig,
            getDashboard,
            cardData,
            corePannelLineChartData,
            getCardChart,
            getCorePannelLineChart
        } = useOverviewData(props, context)
        const activeArray = ref<string[]>([]); // card 的选中指标list
        const allLoading = ref(false);
        const chartsComponents = ref(null) as any;

        // 点击重置
        function clicRest() {
            const conditions = dashboardData.value.conditions
            fillterForm.value = createFilterForm(conditions, props.appId);
        }

        // 点击每个卡片控制下方折线展示
        function clickCard(item: SelectorsType) {
            chartsComponents.value.changeLegend(item.fieldName);
        }

        // 筛选条件变化时清空当前页面所有数据
        function clearAllChartData() {
            // card默认选中项初始化（全都选中）
            activeArray.value = newCardConfig.value!.selectors.map((item: SelectorsType) => item.fieldName)
            cardData.value = [];
            corePannelLineChartData.value = null;
        }

        // 页面初始化
        async function init() {
            // 接口请求顺序 1、incomeData.ts 里的 getDashboard，getDashboard返回查询条件后才会触发watch，init()在watch内
            allLoading.value = true;
            Promise.all([
                // 清空当前页面所有数据
                clearAllChartData(),
                // 获取核心数据概览——card
                getCardChart(),
                // 获取核心概览-折现图chart
                getCorePannelLineChart()
            ]).finally(() => {
                allLoading.value = false;
                context.emit('loadOver', allLoading.value);
                console.log('所有接口请求完毕')
            })
        }

        watch(
            () => fillterForm.value,
            (val) => {
                if(allLoading.value) {
                    handleWarningMessageToast('操作太频繁了，请等一等数据~')
                    return;
                }
                // 页面初始化 之前还会请求 getDashboard，getDashboard返回筛选条件后才会触发watch
                init();
            },
            {
                deep: true
            }
        );
        watch(
            () => props.appId,
            async (val) => {
                if(allLoading.value) {
                    handleWarningMessageToast('操作太频繁了，请等一等数据~')
                    return;
                }
                // 重新请求dashbord，会重置所有筛选条件，触发上方的watch
                getDashboard()
            }
        );


        return {
            chartsComponents,
            clicRest,
            clickCard,
            fillterForm,
            newCardConfig,
            cardData,
            corePannelLineChartData,
            allLoading,
            activeArray
        }
    }
})
